import { DashboardFilterValues, QueuePage, QueueFilterValues } from './types';

// Query keys for the Dashboard V2 React Query hooks. Scoped under the
// `'dashboard_v2'` root so a single
// `queryClient.invalidateQueries({ queryKey: ['dashboard_v2'] })` flushes
// every dashboard query. Sub-keys follow `[root, resource, ...inputs]` so
// changing any input rotates the cache slot.

const ROOT = 'dashboard_v2' as const;

export const dashboardV2QueryKeys = {
  root: [ROOT] as const,
  calendarWeek: (
    agencyId: number,
    startDate: string,
    timeZone: string,
    filters: DashboardFilterValues,
    days = 7,
  ) =>
    [
      ROOT,
      'calendar_week',
      agencyId,
      startDate,
      timeZone,
      filters,
      days,
    ] as const,
  summary: (agencyId: number) => [ROOT, 'summary', agencyId] as const,
  filters: (agencyId: number) => [ROOT, 'filters', agencyId] as const,
  // Queue filters are part of the key, so changing a selection rotates the
  // cache slot instead of serving the previous queue's rows (GRAVY-10303).
  //
  // So is the page, for the same reason: each page is its own server response
  // (GRAVY-10304). Keeping them as separate slots also means paging back to a
  // page already visited renders from cache instead of refetching.
  noShow: (agencyId: number, filters: QueueFilterValues, page: QueuePage) =>
    [ROOT, 'no_show', agencyId, filters, page] as const,
  missingTimesheet: (
    agencyId: number,
    filters: QueueFilterValues,
    page: QueuePage,
  ) => [ROOT, 'missing_timesheet', agencyId, filters, page] as const,
  needsApproval: (
    agencyId: number,
    filters: QueueFilterValues,
    page: QueuePage,
  ) => [ROOT, 'needs_approval', agencyId, filters, page] as const,
  shiftDetail: (agencyId: number, shiftId: number) =>
    [ROOT, 'shift_detail', agencyId, shiftId] as const,
  // shiftId is part of the key, so opening the modal on another shift reads a
  // different cache slot instead of showing the previous shift's history while
  // the new request is in flight (GRAVY-10294).
  shiftActivity: (agencyId: number, shiftId: number) =>
    [ROOT, 'shift_activity', agencyId, shiftId] as const,
};
